import React from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "consts";
import { getApiErrorMessage, useToaster } from "utils";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { DocumentTypeForm } from "./DocumentTypeForm";
import { DocumentTypeModel, documentTypesApi } from "api/documentTypesApi";

export const AddDocumentTypePage = (): JSX.Element => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (data: DocumentTypeModel) => {
    try {
      await documentTypesApi.create(data);
      navigate(routes.DOCUMENT_TYPES);
      showSuccess(`Utworzono typ dokumentu`);
    } catch (e) {
      showError(getApiErrorMessage(e, "Nie udało się utworzyć typu dokumentu"));
      console.error(e);
    }
  };

  const breadcrumbs = [
    { title: "Szablony dokumentów", path: routes.DOCUMENTS },
    { title: "Typy dokumentów", path: routes.DOCUMENT_TYPES },
    { title: "Tworzenie nowego typu dokumentu" },
  ];

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Dodaj nowy typ" />
      <DocumentTypeForm onSubmit={onSubmit} />
    </PageMain>
  );
};
